import React, { useState, useEffect } from "react"
import CurrencyFormat from "react-currency-format";
import { encodeStorage } from 'functions/storageBase64';
import { dateFormat } from 'functions/dateFormat'

export function useConsultaSaldoData(dataConsultaSaldo){
    const [monto, setMonto] = useState('0.00')
    const [mensualidad, setMensualidad] = useState('0.00')
    const [minimo, setMinimo] = useState('0.00')
    const [saldoNuevoCorte, setSaldoNuevoCorte] = useState('0.00')
    const [pagoNoGenerarIntereses, setPagoNoGenerarIntereses] = useState('0.00')
    const [limiteCredito, setLimiteCredito] = useState('0.00')
    const [fechaLimite, setFechaLimite] = useState( dateFormat( '1210101') )
    const [nombreTitular, setNombreTitular] = useState()
    const [cardending, setCardending] = useState('0000')
    const [status, setStatus] = useState(false)
    const [noInternet, setNoInternet] = useState(false)
    const [fechaPago, setFechaPago] = useState(null)
    const [mensaje, setMensajeo] = useState(false)
    const [tipo, setTipo] = useState(false)
    const [cuentaNueva, setCuentaNueva] = useState(1)
    const [newType, setNewType] = useState(0)
    const [nuevoMensaje, setNewMessage] = useState('')
    const [phone, setPhone] = useState('0')
    const [fecharealfacturacion, setFecharealfacturacion] = useState('0')
    const [pendPago, setMontoPendPago] = useState(false)
    const [finish, setFinish] = useState(false)
    const [accountNumber, setAccountNumber] = useState(false)

    const [cardsService, setCardsService ] = useState()
    useEffect(()=>{
        if(dataConsultaSaldo){
            // console.log('dataConsultaSaldo: ', dataConsultaSaldo)
            encodeStorage('lastConsultData', dataConsultaSaldo)
            setCardsService(dataConsultaSaldo)
        }
    },[dataConsultaSaldo])

    const [selectCard, setSelectCard ] = useState()
    const [loading, setLoading] = useState(true)
    useEffect(()=>{
        if(cardsService){
            setLoading(true)
            if(cardsService.length >= 1){
                setSelectCard(true)
            }
        }
    },[cardsService])

    
    useEffect(()=>{
        if(selectCard){
            setMonto(cardsService[0]?.credit_available)
            setMensualidad(cardsService[0]?.monthly_payment)
            setMinimo(cardsService[0]?.minimum_to_pay)
            setSaldoNuevoCorte(cardsService[0]?.new_balance_cutting)
            setPagoNoGenerarIntereses(cardsService[0]?.payment_not_generate_interest)
            setLimiteCredito(cardsService[0]?.credit_imit)
            setStatus(cardsService[0]?.status_app)
            setNoInternet(cardsService[0]?.noInternet)
            setMensajeo(cardsService[0]?.mensaje)
            setTipo(cardsService[0]?.tipo)
            setMontoPendPago(cardsService[0]?.monto_pendiente_pago)
            setCuentaNueva(cardsService[0]?.cuenta_nueva)
            setNewType( Number(cardsService[0]?.new_type) )
            setNewMessage( cardsService[0]?.new_message)
            setAccountNumber( cardsService[0]?.account_number)
            if(cardsService[0]?.payday_limit){
                // setFechaLimite( dateFormat(cardsService[0]?.payday_limit) )
                setFechaLimite( cardsService[0]?.payday_limit )
            }
            if(cardsService[0]?.name){
                setNombreTitular(cardsService[0]?.name+' '+cardsService[0]?.paternal+' '+cardsService[0]?.maternal)
                encodeStorage('nombreTitular', cardsService[0]?.name+' '+cardsService[0]?.paternal+' '+cardsService[0]?.maternal)
            }
            if(cardsService[0]?.email){
                encodeStorage('email', cardsService[0]?.email.toLowerCase())
            }
            if(cardsService[0]?.cards){
                setCardending(cardsService[0]?.cards[0]?.card_number)
                encodeStorage('cardending',cardsService[0]?.cards[0]?.card_number.slice(-4))
                encodeStorage("idCredito",cardsService[0]?.cards[0]?.card_number);
            }
            if(cardsService[0]?.fecharealfacturacion){
                setFecharealfacturacion( cardsService[0]?.fecharealfacturacion)
                encodeStorage("fecharealfacturacion",cardsService[0]?.fecharealfacturacion);
            }
            if(cardsService[0]?.fecha_pago){
                // setFechaLimite( dateFormat(cardsService[0]?.payday_limit) )
                setFechaPago( cardsService[0]?.fecha_pago )
            }
            if(cardsService[0]?.telefono?.length > 4){
                let telefono = `**** ${cardsService[0]?.telefono.substring(cardsService[0]?.telefono.length - 4)}`
                setPhone(telefono)
            }else{
                setPhone(null)
            }
            setFinish(true)
            setLoading(false)
        }
    },[selectCard, cardsService])

    let numeroTarjeta = "** **** *" + cardending.substring(cardending.length - 4)
    let titulo = cardending//"Crédito SEARS *" + cardending

    let saldoDisponible = monto && <CurrencyFormat
        value={Number(monto % 1) === 0 ? monto + '.001' : monto}
        displayType={'text'}
        decimalScale={2}
        FixedDecimalScale={true}
        thousandSeparator={true} prefix={'$'} renderText={value => <>{value} </>}
    />;

    let montoMensualidad = mensualidad && mensualidad!= 0 && <CurrencyFormat
        value={Number(mensualidad % 1) === 0 ? mensualidad + '.001' : mensualidad}
        displayType={'text'}
        decimalScale={2}
        FixedDecimalScale={true}
        thousandSeparator={true} prefix={'$'} renderText={value => <>{value} </>} />;

    let montoMinimo = minimo && <CurrencyFormat
        value={Number(minimo % 1) === 0 ? minimo + '.001' : minimo}
        displayType={'text'}
        decimalScale={2}
        FixedDecimalScale={true}
        thousandSeparator={true} prefix={'$'} renderText={value => <>{value} </>} />;

    let montoNuevoCorte = saldoNuevoCorte && saldoNuevoCorte != 0 &&<CurrencyFormat
        value={Number(saldoNuevoCorte % 1) === 0 ? saldoNuevoCorte + '.001' : saldoNuevoCorte}
        displayType={'text'}
        decimalScale={2}
        FixedDecimalScale={true}
        thousandSeparator={true} prefix={'$'} renderText={value => <>{value} </>} />;

    let montoPagoNoGenerarIntereses = pagoNoGenerarIntereses && pagoNoGenerarIntereses!=0 && <CurrencyFormat
        value={Number(pagoNoGenerarIntereses % 1) === 0 ? pagoNoGenerarIntereses + '.001' : pagoNoGenerarIntereses}
        displayType={'text'}
        decimalScale={2}
        FixedDecimalScale={true}
        thousandSeparator={true} prefix={'$'} renderText={value => <>{value} </>} />;

    let montoLimiteCredito = limiteCredito && <CurrencyFormat
        value={Number(limiteCredito % 1) === 0 ? limiteCredito + '.001' : limiteCredito}
        displayType={'text'}
        decimalScale={2}
        FixedDecimalScale={true}
        thousandSeparator={true} prefix={'$'} renderText={value => <>{value} </>} />;

    let montoPendPago = pendPago && <CurrencyFormat
        value={Number(pendPago % 1) === 0 ? pendPago + '.001' : pendPago}
        displayType={'text'}
        decimalScale={2}
        FixedDecimalScale={true}
        thousandSeparator={true} prefix={'$'} renderText={value => <>{value} </>} />;

    let responseOrigin = {
        saldoDisponible: monto,
        montoMensualidad: mensualidad,
        montoMinimo: minimo,
        montoNuevoCorte: saldoNuevoCorte,
        montoPagoNoGenerarIntereses: pagoNoGenerarIntereses,
        montoLimiteCredito: limiteCredito,
        montoPendPago: pendPago
    }
   
    const dataSaldos = {
        numeroTarjeta,
        saldoDisponible,
        montoMensualidad,
        montoMinimo,
        montoNuevoCorte,
        montoPagoNoGenerarIntereses,
        montoLimiteCredito,
        fechaLimite,
        fechaPago,
        nombreTitular,
        phone,
        titulo,
        accountNumber,
        cardending,
        status,
        noInternet,
        montoPendPago,
        tipo,
        cuentaNueva,
        newType,
        mensaje,
        nuevoMensaje,
        responseOrigin,
        fecharealfacturacion,
        finish
    }
    const upDateDataSaldos = updateDataCard => setCardsService(updateDataCard)
        
    return {
        dataSaldos,
        loading,
        upDateDataSaldos
    }
}